<template>
    <v-app>
        <div class="card card-custom">
            <div class="card-body p-0">
                <div class="wizard wizard-2" id="kt_wizard_v2" data-wizard-state="step-first" data-wizard-clickable="true">
                    <div class="wizard-body py-8 px-8 py-lg-10 px-lg-10">
                        <div class="row">
                            <div class="col-6">
                                <h4>
                                    Exam candidates
                                </h4>
                            </div>
                            
                            <div class="col-12">
                                <div class="scroll-x-auto">
                                    <v-skeleton-loader type="table-thead" v-if="loading">
                                    </v-skeleton-loader>

                                    <v-skeleton-loader v-if="loading" type="table-row-divider@25">
                                    </v-skeleton-loader>

                                    <table class="table" v-if="!loading">
                                        <thead>
                                            <tr class="px-3">
                                                <th class="px-3 wrap-column">Student info</th>
                                                <th class="pr-3">Action</th>
                                            </tr>
                                        </thead>
                                        
                                        <tbody>
                                            <tr v-if="enrollments.length > 0" v-for="(enrollment, index) in enrollments">
                                                <td class="px-3 wrap-column">
                                                    <div>
                                                        {{ enrollment.full_name }}
                                                    </div>
                                                    <div class="mt-2">
                                                        <strong>{{ enrollment.symbol_no ? enrollment.symbol_no : 'NA'  }}</strong>
                                                    </div>
                                                    <div class="mt-2">
                                                        <span class="badge badge-warning" v-if="enrollment.exam_status == 'pending'">
                                                            {{ enrollment.exam_status ? 'Exam '+enrollment.exam_status_text : 'NA'  }}
                                                        </span>
                                                        <span class="badge badge-success" v-if="enrollment.exam_status == 'attended'">
                                                            {{ enrollment.exam_status ? 'Exam '+enrollment.exam_status_text : 'NA'  }}
                                                        </span>
                                                        <span class="badge badge-danger" v-if="enrollment.exam_status == 'not_attended'">
                                                            {{ enrollment.exam_status ? 'Exam '+enrollment.exam_status_text : 'NA'  }}
                                                        </span>
                                                    </div>
                                                </td>

                                                <td class="pr-0">
                                                    <b-dropdown size="sm" variant="link"
                                                        toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                                                        no-caret right no-flip>
                                                        <template v-slot:button-content>
                                                            <slot>
                                                                <span>
                                                                    <i class="flaticon-more-1"></i>
                                                                </span>
                                                            </slot>
                                                        </template>
                                                        <!--begin::Navigation-->
                                                        <div class="navi navi-hover ">
                                                            <b-dropdown-text tag="div" class="navi-item" v-if="enrollment.exam_status == 'pending' || enrollment.exam_status == 'not_attended'">
                                                                <a href="#" class="navi-link" @click="markAsAttended(enrollment.id)">
                                                                    <span class="navi-icon">
                                                                        <i class="fa fa-check-circle"></i>
                                                                    </span>
                                                                    <span class="navi-text"> Mark as attended </span>
                                                                </a>
                                                            </b-dropdown-text>

                                                            <b-dropdown-text tag="div" class="navi-item" v-if="enrollment.exam_status == 'pending' || enrollment.exam_status == 'attended'">
                                                                <a href="#" class="navi-link" @click="markAsNotAttended(enrollment.id)">
                                                                    <span class="navi-icon">
                                                                        <i class="fa fa-times-circle"></i>
                                                                    </span>
                                                                    <span class="navi-text"> Mark as not attended </span>
                                                                </a>
                                                            </b-dropdown-text>
                                                        </div>
                                                    </b-dropdown>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <b-pagination v-if="enrollments.length > 0" class="" @input="getEnrollments" v-model="page"
                                    :total-rows="total" :per-page="perPage" first-number last-number
                                    :disabled="loading"></b-pagination>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        </div>
    </v-app>
</template>

<script>
import UserEnrollmentInfoService from "@/core/services/kiosk/user-enrollment-info/UserEnrollmentInfoService";

const userEnrollmentInfo = new UserEnrollmentInfoService();

export default {
    data() {
        return {
            enrollments: [],
            search: {
                exam_status: '',
                registration_status: 'active',
                limit: 10,
                status: "complete",
                start_date: "",
                end_date: "",
                type: "pre_registration",
                is_paid:'all',
                entrance_status:'all',
                entrance_exam_id:null,
            },
            page: null,
            total: null,
            perPage: null,
            loading: false,
            total_result: null,
            entrance: ''
        }
    },
    methods:{
        getEnrollments() {
            this.loading = true;
            this.setEntranceExamId();

            userEnrollmentInfo
            .paginate(this.search, this.page)
            .then(response => {
                this.enrollments = response.data.data;
                this.page = response.data.meta.current_page;
                this.total = response.data.meta.total;
                this.perPage = parseInt(response.data.meta.per_page);
                this.total_result = response.data.meta.total
            })
            .catch((err) => {
            })
            .finally(() => {
                this.loading = false
            });
        },

        markAsAttended(id){
                this.$confirm({
                    message: `Are you sure you want to mark as attended?`,
                    button: {
                        no: "No",
                        yes: "Yes",
                    },
                    callback: (confirm) => {
                    if (confirm) {
                        userEnrollmentInfo
                        .markAsAttended(id)
                        .then((response) => {
                            this.$snotify.success("Marked as attended");
                            this.getEnrollments();
                        })
                        .catch((err) => {
                            this.$snotify.error(
                            "Something went wrong. Please try again later!!"
                            );
                        });
                    }
                    },
                });
            },

            markAsNotAttended(id){
                this.$confirm({
                    message: `Are you sure you want to mark as not attended?`,
                    button: {
                        no: "No",
                        yes: "Yes",
                    },
                    callback: (confirm) => {
                    if (confirm) {
                        userEnrollmentInfo
                        .markAsNotAttended(id)
                        .then((response) => {
                            this.$snotify.success("Marked as not attended");
                            this.getEnrollments();
                        })
                        .catch((err) => {
                            this.$snotify.error(
                            "Something went wrong. Please try again later!!"
                            );
                        });
                    }
                    },
                });
            },

        setEntranceExamId(){
            this.search.entrance_exam_id = this.examId;
        }
    },
    mounted() {
        this.getEnrollments();
    },
    computed: {
        examId() {
            return this.$route.params.examId;
        }
    }
}
</script>

<style scoped>
    .wrap-column{
        max-width: 100px !important; 
        white-space: pre-wrap;
    }
</style>